module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="formLine">\r\n    <div class="form-group col-xs-3 inputField">\r\n        <select id="fieldName" class="form-control">\r\n                <option value="">--</option>\r\n                <option value="denominacion">'+
((__t=(lang.DENOMINACION))==null?'':_.escape(__t))+
'</option>\r\n                <option value="epigraph">'+
((__t=(lang.EPIGRAFE))==null?'':_.escape(__t))+
'</option>\r\n                <option value="areaFuncional">'+
((__t=(lang.A_FUNCIONAL))==null?'':_.escape(__t))+
'</option>\r\n                <option value="juridicos_uso">'+
((__t=(lang.USO))==null?'':_.escape(__t))+
'</option> \r\n                <option value="fechaAlta">'+
((__t=(lang.FECHA_ALTA))==null?'':_.escape(__t))+
'</option>\r\n                <option value="codigo">'+
((__t=(lang.CODIGO))==null?'':_.escape(__t))+
'</option>\r\n            </select>\r\n    </div>\r\n    <div class="form-group col-xs-2 inputField" id="operatorHolder">\r\n        <select id="nbcomparador" class="form-control operator"> \r\n                <option value="<">'+
((__t=(lang.MENOR_QUE))==null?'':_.escape(__t))+
'</option>  \r\n            </select>\r\n        <select id="nbIgual" class="form-control operator" disabled>\r\n                <option value="=" selected>'+
((__t=(lang.IGUAL_A))==null?'':_.escape(__t))+
'</option>\r\n            </select>\r\n        <select id="nbIncluye" class="form-control operator" disabled>\r\n                <option value="like" selected>'+
((__t=(lang.INCLUYE))==null?'':_.escape(__t))+
'</option>\r\n            </select>\r\n    </div>\r\n    <div class="form-group col-xs-3 inputField" id="valueHolder">\r\n        <input type="text" id="textValue" class="form-control value" />\r\n        <input type="number" step="0.001" id="numberValue" class="form-control value" />\r\n        <div id=\'dtpickerBuscar\' class="input-group dateGroup  ">\r\n            <input type=\'text\' id="dateValue" name="start" class="form-control date value" />\r\n            <span class="input-group-addon">\r\n                    <span class="glyphicon glyphicon-calendar"></span>\r\n            </span>\r\n        </div>\r\n        <select id="epigraphValue" class="form-control value">\r\n            ';

                for (var i in params.epigraphs){
                    print('<option value="'+ params.epigraphs[i].word + '">'+ lang[params.epigraphs[i].word] + '</option>');
                }
            
__p+='\r\n            </select>\r\n        <select id="usoValue" class="form-control value">\r\n            ';

                for (i in params.uso){
                    print('<option value="'+ params.uso[i].word + '">'+ lang[params.uso[i].word] + '</option>');
                }
            
__p+='\r\n            </select>\r\n        <select id="areaValue" class="form-control value">\r\n            ';

                for (i in params.areas){
                    print('<option value="' + params.areas[i].word + '">'+ lang[params.areas[i].word] + '</option>');
                }
            
__p+='\r\n            </select>\r\n\r\n        <select id="codeValue" class="form-control value">\r\n                ';

                    set = new Set();
                    for (i in params.amortizaciones){
                        set.add(params.amortizaciones[i].cc_inmobil);
                    }
                    array = new Array();
                    array = Array.from(set);
                    function comparar ( a, b ){ return a - b; }
                    array.sort(comparar);
                    for (v in array){
                        print('<option value="' + array[v] + '">'+ array[v] + '</option>');
                    }
                
__p+='\r\n                </select>\r\n    </div>\r\n    <div class="form-group col-xs-2 inputField">\r\n        <select id="operator" class="form-control">\r\n                <option>--</option>\r\n                <option value="and">'+
((__t=(lang.AND))==null?'':_.escape(__t))+
'</option>\r\n                <option value="or">'+
((__t=(lang.OR))==null?'':_.escape(__t))+
'</option>\r\n            </select>\r\n    </div>\r\n    <div class="form-group col-xs-2 inputField">\r\n        <span class="searchButton add ion ion-ios-plus text-green"></span>\r\n        <span class="searchButton remove ion-ios-close text-red"></span>\r\n    </div>\r\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/views/report/formLine.ejs
// module id = 442
// module chunks = 0